export default {
    type: 'numeric',
    format: {
        decimals: 2,
        min: 0,
        currency: true
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: { },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Estimated Worth',
        category: 'Game',
        description: 'The estimated value of the game based on online sales.',
        summarise: {
            prefix: 'Estimated worth'
        }
    },
    rules: {
        linked: [],
        legacy: ['worth.value']
    }
}